import { RightArrow2Outlined } from 'dd-icons';
import './PsychiatristHistory.less'
import { _getPsychologicalRecord } from '@/api/user'
import { useEffect, useState } from 'react';
import useHistory from '@/hooks/useHistory'


const PsychiatristHistory = () => {
  const [list, setList] = useState([])
  const history = useHistory()
  

  const getHistoryList = () => {
    _getPsychologicalRecord().then(res => {
      const [d, result] = res
      if (d && result && result.length > 0) {
        setList(result)
      }
    })
  }

  const handleClick = (id) => {
    history.push('/PsychiatristDetail?id=' + id, 'route')
  }

  useEffect(() => {
    getHistoryList()
  }, [])

  return (
    <div className="pg-psychiatrist-history">
      <div className="pg-psychiatrist-history--container">
        {
          list.length !== 0 ?
          <>
            {
              list.map(item => {
                return (
                  <div className="row" key={ item.id } onClick={() => handleClick(item.id)}>
                    <div className='label'>
                      <div className='title'>{ item.content }</div>
                      <div className='time'>{ item.submitDate }</div>
                    </div>
                    <RightArrow2Outlined className='icon' />
                  </div>
                )
              })
            }
            <div className='no-more'>没有更多了~</div>
          </>:
          <div className='pg-empty'>
            <img className='icon' src='https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/default.png' />
            <div className='tips'>暂无历史记录</div>
          </div>
        }

        
      </div>
    </div>
  )
}

export default PsychiatristHistory